import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBannerMsg } from '../actions/FlashMessage/FlashMessages';
import ReactGA from 'react-ga';
import { _setStorageTimeout } from '../utils/helpers';
import { fetchSessionUserInstitutions } from '../actions/Users/UserAction';
import { fetchAssociationsList } from '../actions/AssociationAndOrg/AssociationOrgAction';
import { fetchGlobalInstitutions } from '../actions/Institutions/InstitutionsAction';
import gtmService from '../services/GTMService';

const PUBLIC_ROUTES = ['login', 'signup', 'forgotPassword', 'resetpassword', 'accountLocked'];

const logPageView = () => {
  let pathname = window.location.pathname;
  let pathList = pathname.split('/');
  let path = pathList[pathList.length - 1];

  if (PUBLIC_ROUTES.indexOf(path) >= 0) {
    _setStorageTimeout();
  }

  // GA3 tracking (existing)
  ReactGA.set({ page: pathname });
  ReactGA.pageview(pathname);
  
  // GTM tracking (new) - track page views
  gtmService.trackPageView(pathname, document.title, {
    page_location: window.location.href,
    referrer: document.referrer || 'direct'
  });
  
  return null;
}

export const RootRouter = () => {
  const dispatch = useDispatch();
  const sessionToken = useSelector(state => state.AppSession.token);
  const userIsReady = useSelector(state => !!state.AppSession.userDetails.userRoleConstant);

  useEffect(() => {
    logPageView();
  }, []);

  // Track page changes for GTM and GA when location changes
  useEffect(() => {
    const handleLocationChange = () => {
      logPageView();
    };
    
    // Listen for browser navigation changes
    window.addEventListener('popstate', handleLocationChange);
    
    return () => {
      window.removeEventListener('popstate', handleLocationChange);
    };
  }, []);

  useEffect(() => {
    sessionToken && userIsReady ? dispatch(fetchBannerMsg()) : void 0;
    sessionToken && userIsReady ? dispatch(fetchSessionUserInstitutions()) : void 0;
    sessionToken && userIsReady ? dispatch(fetchAssociationsList()) : void 0;
    sessionToken && userIsReady ? dispatch(fetchGlobalInstitutions()) : void 0;
  }, [sessionToken, userIsReady]);

  return null;
}

export default RootRouter;
